import { throttle } from "./Util";


function scrollAnimationSliderItem() {
    let heightViewport = $("html").height();
    $(".stream-wrap-slider").each(function (idx, itm) {
        let postion = $(itm).offset().top;
        let height = $(itm).height();

        let scroll = App.W.scrollTop();
        if (
            scroll > postion - heightViewport + 100 &&
            scroll < postion + height - heightViewport + 100
        ) {
            $(itm).addClass("_animate");
        }
    });
}

let scrollAnimationSliderItemThrottle = throttle(
    scrollAnimationSliderItem,
    100
);

if (App.H.hasClass("page-stream")) {
    App.W.on("barba:afterEnter", () => {
        App.H.addClass("_noscroll-animate");

        setTimeout(() => {
            $(".animate-to-right").addClass("_animate");
        }, 1200);

        setTimeout(() => {
            $(".stream-top-event").addClass("_animate");
        }, 2200);

        setTimeout(() => {
            App.H.removeClass("_noscroll-animate");
        }, 2600);
    });

    function scrollAnimationEventSpeakers() {
        let postion = $(".event-speakers").offset().top;
        let height = $(".event-speakers").height();
        let heightViewport = $("html").height();

        let scroll = App.W.scrollTop();
        if (
            scroll > postion - heightViewport + 150 &&
            scroll < postion + height - heightViewport + 150
        ) {
            $(".event-speakers").addClass("_animate");
        }
    }

    let scrollAnimationEventSpeakersThrottle = throttle(
        scrollAnimationEventSpeakers,
        100
    );
    
    App.W.on("scroll", () => {
        scrollAnimationSliderItemThrottle();
        scrollAnimationEventSpeakersThrottle();
    });
}

if (App.H.hasClass("page-main-v2")) {
    // App.W.on("barba:afterEnter", () => {
    //     App.H.addClass("_noscroll-animate");
    //     setTimeout(() => {
    //         $(".bg-start").addClass("_animate");
    //     }, 1600);

    //     setTimeout(() => {
    //         $(".first-screen__advantage").addClass("_animate");
    //     }, 2600);

    //     setTimeout(() => {
    //         $(".video-sticky").addClass("_animate");
    //     }, 3150);

    //     setTimeout(() => {
    //         App.H.removeClass("_noscroll-animate");
    //     }, 3500);
    // });

    function scrollAnimationExperience() {
        let postion = $(".experience-top").offset().top;
        let height = $(".experience-top").height();
        let heightViewport = $("html").height();

        let scroll = App.W.scrollTop();
        if (
            scroll > postion - heightViewport + 250 &&
            scroll < postion + height - heightViewport + 250
        ) {
            $(".experience-top").addClass("_animate");
            $(".experience-top__right a").addClass("_animate");
        }
    }

    function scrollAnimationCases() {
        let postion = $(".cases-wrap").offset().top;
        let height = $(".cases-wrap").height();
        let heightViewport = $("html").height();

        let scroll = App.W.scrollTop();
        if (
            scroll > postion - heightViewport + 250 &&
            scroll < postion + height - heightViewport + 250
        ) {
            $(".cases-wrap").addClass("_animate");
        }
    }

    let scrollAnimationCasesThrottle = throttle(scrollAnimationCases, 100);

    function scrollAnimationExpertise() {
        let heightViewport = $("html").height();
        $(".expertise").each(function (idx, itm) {
            let postion = $(itm).offset().top;
            let height = $(itm).height();

            let scroll = App.W.scrollTop();
            if (
                scroll > postion - heightViewport + 600 &&
                scroll < postion + height - heightViewport + 600
            ) {
                $(itm).addClass("_animate");
            }
        });
    }

    let scrollAnimationExpertiseThrottle = throttle(
        scrollAnimationExpertise,
        100
    );

    function scrollExperience() {
        let heightViewport = $("html").height();
        $(".experience-item").each(function (idx, itm) {
            let postion = $(itm).offset().top;
            let height = $(itm).height();

            let scroll = App.W.scrollTop();
            if (
                scroll > postion - heightViewport + 250 &&
                scroll < postion + height - heightViewport + 250
            ) {
                $(itm).addClass("_animate");
            }
        });
    }

    let scrollExperienceThrottle = throttle(
        scrollExperience,
        100
    );

    function scrollAnimationCaseItem() {
        let heightViewport = $("html").height();
        $(".multi-item").each(function (idx, itm) {
            let postion = $(itm).offset().top;
            let height = $(itm).height();

            let scroll = App.W.scrollTop();
            if (
                scroll > postion - heightViewport + 100 &&
                scroll < postion + height - heightViewport + 100
            ) {
                $(itm).addClass("_animate");
            }
        });
    }

    let scrollAnimationCaseItemThrottle = throttle(
        scrollAnimationCaseItem,
        100
    );

    function scrollAnimationClients() {
        let postion = $(".clients-top").offset().top;
        let height = $(".clients-top").height();
        let heightViewport = $("html").height();

        let scroll = App.W.scrollTop();
        if (
            scroll > postion - heightViewport + 250 &&
            scroll < postion + height - heightViewport + 250
        ) {
            $(".clients-top").addClass("_animate");
            $(".clients-title").addClass("_animate");
        }
    }

    let scrollAnimationExperienceThrottle = throttle(
        scrollAnimationExperience,
        100
    );
    let scrollAnimationClientsThrottle = throttle(scrollAnimationClients, 100);

    App.W.on("scroll", () => {
        scrollAnimationExperienceThrottle();
        scrollAnimationClientsThrottle();
        scrollAnimationExpertiseThrottle();
        scrollAnimationCasesThrottle();
        scrollAnimationCaseItemThrottle();
        scrollExperienceThrottle();
        scrollAnimationSliderItemThrottle();
    });
}

if ($(".page-contacts").length) { 
    const timeStepAnimate = 80;
    const lengthLinksItem = $('.contacts-links-item').length + 1;

    setTimeout(() => {
        $('.contacts-links-item').each(function (idx, itm) {
            setTimeout(() => {
                $(itm).addClass('_animate');
            }, idx * timeStepAnimate);
        });

        $('.contacts-info-item').each(function (idx, itm) {
            setTimeout(() => {
                $(itm).addClass('_animate');
            }, idx * timeStepAnimate);
        });

        setTimeout(() => {
            $('.policy-text').addClass('_animate');
        }, lengthLinksItem * timeStepAnimate);
    }, 1600);

    function scrollAnimationPersonCard() {
        let heightViewport = $("html").height();
        $(".person-list-item").each(function (idx, itm) {
            let postion = $(itm).offset().top;
            let height = $(itm).height();

            let scroll = App.W.scrollTop();
            if (
                scroll > postion - heightViewport + 350 &&
                scroll < postion + height - heightViewport + 350
            ) {
                $(itm).addClass("_animate");
            }
        });
    }

    function scrollAnimationSocial() {
        const $socialBlock = $('.contacts-social-list');
        let heightViewport = $("html").height();
        let postionSocialBlock = $socialBlock.offset().top;
        let heightSocialBlock = $socialBlock.height();

        let scroll = App.W.scrollTop();
        if (
            scroll > postionSocialBlock - heightViewport + 350 &&
            scroll < postionSocialBlock + heightSocialBlock - heightViewport + 350
        ) {
            $socialBlock.addClass("_animate");
        }
    }

    function scrollAnimationText() {
        const $textBlock = $('.contacts-social-title');
        let heightViewport = $("html").height();
        let postionText = $textBlock.offset().top;
        let heightText = $textBlock.height();

        let scroll = App.W.scrollTop();
        if (
            scroll > postionText - heightViewport + 350 &&
            scroll < postionText + heightText - heightViewport + 350
        ) {
            $textBlock.addClass("_animate");
        }
    }

    let scrollAnimationPersonCardThrottle = throttle(scrollAnimationPersonCard, 100);
    let scrollAnimationSocialThrottle = throttle(scrollAnimationSocial, 100);
    let scrollAnimationTextThrottle = throttle(scrollAnimationText, 100);

    App.W.on("scroll", () => {
        scrollAnimationPersonCardThrottle();
        scrollAnimationTextThrottle();
        scrollAnimationSocialThrottle();
    });
}


// WEBPACK FOOTER //
// ./_src/js/modules/Animation.js